import { isIOSEmbeddedAndStandalone } from '../../client';
import { callNative, requestTypes } from '../../lib/bridge';

class InAppBrowser {
  static isAvailable = () => {
    if (isIOSEmbeddedAndStandalone) {
      return true;
    }

    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if (window.InAppBrowser && window.InAppBrowser.openUrl) {
      return true;
    }

    return false;
  };

  static open = async (url: string, postParams: unknown) => {
    try {
      console.log('INAPP OPEN BEGIN', url, postParams);

      let result = null;

      // Sur iOS on fait un callNative qui va déclencher le webkitHandler et attendre la réponse via la promesse
      if (isIOSEmbeddedAndStandalone) {
        result = await callNative(requestTypes.IAP_OPEN, JSON.stringify({ url, postParams }));

        console.log('INAPP OPEN END');
        return result?.data ?? {};
      }

      // Sinon, on regard si le plugin natif existe
      if (window.InAppBrowser && window.InAppBrowser.openUrl) {
        result = await callNative(requestTypes.IAP_OPEN, JSON.stringify({ url, postParams }));

        console.log('INAPP OPEN END');
        return result?.data ?? {};
      }
    } catch (e) {
      console.log('InAppBrowser plugin not available');
    }

    return null;
  };
}

export default InAppBrowser;
